import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { Box } from '@mui/material';
import { AIComp } from './AIcomp';
import { DesktopAIProps } from './types';

export function DesktopAI(props: DesktopAIProps) {
  const { type, toggleOpen, actions, ...otherProps } = props;

  const [open, setOpen] = useState(false);
  const handleToggleOpen = () => {
    setOpen(!open);
    toggleOpen();
  };

  const buttonStyles = useSpring({
    to: { opacity: open ? 0 : 1, transform: open ? 'scale(0)' : 'scale(1)' },
    from: { opacity: 1, transform: 'scale(1)' },
    config: { duration: 350 }
  });

  const dialogStyles = useSpring({
    scale: open ? 1 : 0,
    borderRadius: open ? '16px' : '50%',
    opacity: open ? 1 : 0,
    transformOrigin: 'bottom right',
    config: { tension: 300, friction: 20, duration: 350 },
  });

  return (
    <Box position='fixed' bottom={40} right={40} zIndex={1200}
      width={ open ? '500px' : '100px' } height={ open ? '600px' : '100px' }
    >
      <animated.button
        style={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100px',
          height: '100px',
          cursor: 'pointer',
          border: 'none',
          backgroundColor:'transparent',
          backgroundImage: 'url(/images/AI/bg.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          ...buttonStyles
        }}
        className="bg-blue-500 text-white p-2 rounded-full focus:outline-none"
        onClick={handleToggleOpen}
      >
        <img src="/images/AI/animate.gif"
          alt="Animated Icon"
          style={{
            width: '60px',
            height: '60px',
            marginBottom: '12px'
          }}
        />
      </animated.button>
      <animated.div
        style={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '550px',
          height: 'calc(100vh - 200px)',
          backgroundColor: '#f5f5f5',
          overflow: 'hidden',
          boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2),'
          + '0px 2px 10px 1px rgba(0,0,0,0.14),'
          +'0px 3px 18px 4px rgba(0,0,0,0.12)',
          ...dialogStyles
        }}
      >
        <AIComp
          {...otherProps}
          type={type}
          toggleOpen={handleToggleOpen}
          actions={actions}
        />
      </animated.div>
    </Box>
  );
}
